import OpenSponsoredEpisodeModalButton from './OpenSponsoredEpisodeModalButton';

export default OpenSponsoredEpisodeModalButton;
